import React, { lazy, Suspense, useEffect } from 'react'
import { Route, Switch, Redirect, useHistory } from "react-router-dom";

import NavbarMenu from "../components/NavbarMenu";
import RoleRouteGuard from "../components/RoleRouteGuard";
import SchoolReport from "../screens/officer/SchoolReport";
import VcReport from '../screens/officer/vcReport';
const Login = lazy(() => import("../screens/Login"));
const Logout = lazy(() => import("../screens/Auth/Logout"));
// import registration from "../screens/Auth/Registration";
// import forgotpassword from "../screens/Auth/ForgotPassword";
// import page404 from "../screens/Auth/Page404";
// import page403 from "../screens/Auth/Page403";
// import page500 from "../screens/Auth/Page500";
// import page503 from "../screens/Auth/Page503";

// import MyTable from "../screens/Dashbord/MyTable";
// import MyForm from "../screens/Dashbord/MyForm"
const AddComplain = lazy(() => import("../screens/AddComplain"));
const ViewComplain = lazy(() => import("../screens/ViewComplain"));
const ActionLog = lazy(() => import('../screens/ActionLog'));
const CreateAccount = lazy(() => import('../screens/CreateAccount'));
const UserList = lazy(() => import('../screens/UserList'));
const WorkflowQueue = lazy(() => import('../screens/WorkflowQueue'));
const MyComplaints = lazy(() => import('../screens/MyComplaints'));
const WorkflowProcessedHistory = lazy(() => import('../screens/WorkflowProcessedHistory'));
const WorkflowOfficerStatus = lazy(() => import('../screens/WorkflowOfficerStatus'));
const WorkflowSettings = lazy(() => import('../screens/WorkflowSettings'));
const OrgStructure = lazy(() => import('../screens/OrgStructure'));
const ComplaintCategory = lazy(() => import('../screens/ComplaintCategory'));
const Dashboard = lazy(() => import('../screens/Dashbord'));

//BEo _DEO
const BEODash = lazy(() => import('../screens/officer/dashboard'));
const BEOComplain = lazy(() => import('../screens/officer/complain'));
const BEOComplainInfo = lazy(() => import('../screens/officer/complainInfo'));
const BEOActionLog = lazy(() => import('../screens/officer/actionLog'));
const BEOAuth = lazy(() => import('../screens/officer/auth'));
const Reports = lazy(() => import('../screens/Report'));
const PendencyReport = lazy(() => import('../screens/pendencyReport'));
const PendencyReportCat = lazy(() => import('../screens/pendencyReportCategory'));
const PendencyReportCount = lazy(() => import('../screens/pendencyReport/singleView'));
const PendencyReportOfficer = lazy(() => import('../screens/officer/pendencyReportOfficer'));
const PendencyReportOfficerCount = lazy(() => import('../screens/officer/pendencyReportOfficer/singleView'));
const SchoolVCData = lazy(() => import('../screens/officer/schoolVCData'));

// Landing at "/" — field officers are sent to their portal (once, on mount, so
// it can't loop like a declarative <Redirect>); everyone else gets the admin
// dashboard. Handles both fresh logins and refreshing/navigating to "/".
const HomeLanding = ({ designation, scope, districtName, Dashboard }) => {
    const history = useHistory();
    let target = null;
    if (designation) {
        if (scope === "SUBTREE") {
            target = districtName
                ? "/pendency-officer?type=DISTRICT&code=0&category=all&assigned=all"
                : "/pendency-officer?type=STATE&code=0&category=all&assigned=all";
        } else {
            target = "/officer/dash";
        }
    }
    useEffect(() => {
        if (target) history.replace(target);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (target) return <div style={{ padding: 24 }}>Loading…</div>;
    return <Dashboard />;
};

const RouteData = (props) => {
    let res = window.location.pathname;
    let baseUrl = process.env.PUBLIC_URL;
    baseUrl = baseUrl.split("/");
    res = res.split("/");
    res = res.length > 0 ? res[baseUrl.length] : "/";
    res = res ? res : "/";
    const activeKey1 = res;

    // Wait until the stored session has been read before deciding anything,
    // otherwise a refresh on a deep link would redirect a logged-in user to login.
    if (!props.authChecked) {
        return <div />;
    }

    return (
        <div>
            <Suspense fallback={<div>Loading...</div>}>
                {!props.token ? (
                    <Switch>
                        {/* <Route exact path={`${process.env.PUBLIC_URL}`} component={Login} /> */}
                        <Route
                            exact
                            path={`/`}
                            component={Login}
                        />
                        <Route
                            exact
                            path={`/login`}
                            component={Login}
                        />
                        <Route
                            exact
                            path={`/sso/auth/:token`}
                            component={BEOAuth}
                        />

                        <Route
                            exact
                            path={`/pendency`}
                            component={PendencyReport}
                        />
                        <Route
                            exact
                            path={`/pendency-category`}
                            component={PendencyReportCat}
                        />
                        {/* <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/forgotpassword`}
                        component={forgotpassword}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/page404`}
                        component={page404}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/page403`}
                        component={page403}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/page500`}
                        component={page500}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/page503`}
                        component={page503}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/registration`}
                        component={registration}
                    />
                    <Route exact path={`registration`} component={registration} />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/lockscreen`}
                        component={lockscreen}
                    />
                    <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/maintanance`}
                        component={maintanance}
                    /> */}
                        {/* Any other URL opened without a session goes to login,
                            remembering where the user was headed. */}
                        <Route
                            render={({ location }) => (
                                <Redirect
                                    to={{
                                        pathname: "/login",
                                        state: {
                                            from: `${location.pathname}${location.search}`,
                                        },
                                    }}
                                />
                            )}
                        />
                    </Switch>
                ) : (
                    <>
                        <NavbarMenu history={props.history} activeKey={activeKey1} />
                        <RoleRouteGuard>
                        <div id="main-content">
                            <Switch>
                                {/* Just signed in — resume the page they originally asked for */}
                                <Route
                                    exact
                                    path="/login"
                                    render={({ location }) => (
                                        <Redirect to={location.state?.from || "/"} />
                                    )}
                                />
                                <Route
                                    exact
                                    path={`/`}
                                    render={() => (
                                        <HomeLanding
                                            designation={props.designation}
                                            scope={props.scope}
                                            districtName={props.districtName}
                                            Dashboard={Dashboard}
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path={`/add-complain`}
                                    component={AddComplain}
                                />
                                <Route
                                    exact
                                    path={`/view-complain`}
                                    component={ViewComplain}
                                />
                                <Route
                                    exact
                                    path={`/create-account`}
                                    component={CreateAccount}
                                />
                                <Route
                                    exact
                                    path={`/user-list`}
                                    component={UserList}
                                />
                                <Route
                                    exact
                                    path={`/pending-on-me`}
                                    component={MyComplaints}
                                />
                                <Route
                                    exact
                                    path={`/workflow-queue`}
                                    component={WorkflowQueue}
                                />
                                <Route
                                    exact
                                    path={`/workflow-history`}
                                    component={WorkflowProcessedHistory}
                                />
                                <Route
                                    exact
                                    path={`/org-structure`}
                                    component={OrgStructure}
                                />
                                <Route
                                    exact
                                    path={`/complaint-category`}
                                    component={ComplaintCategory}
                                />
                                <Route
                                    exact
                                    path={`/workflow-officer-status`}
                                    component={WorkflowOfficerStatus}
                                />
                                <Route
                                    exact
                                    path={`/workflow-settings`}
                                    component={WorkflowSettings}
                                />
                                <Route
                                    exact
                                    path={`/logout`}
                                    component={Logout}
                                />
                                <Route
                                    exact
                                    path={`/action-log/:id`}
                                    component={ActionLog}
                                />
                                <Route
                                    exact
                                    path={`/reports`}
                                    component={Reports}
                                />
                                <Route
                                    exact
                                    path={`/officer/dash`}
                                    component={BEODash}
                                />
                                <Route
                                    exact
                                    path={`/officer/complain/:status`}
                                    component={BEOComplain}
                                />
                                <Route
                                    exact
                                    path={`/officer/complainInfo/:id/:status`}
                                    component={BEOComplainInfo}
                                />
                                <Route
                                    exact
                                    path={`/officer/actionLog/:id/:status`}
                                    component={BEOActionLog}
                                />
                                <Route
                                    exact
                                    path={`/sso/auth/:token`}
                                    component={BEOAuth}
                                />
                                <Route
                                    exact
                                    path={`/pendency`}
                                    component={PendencyReport}
                                />
                                <Route
                                    exact
                                    path={`/pendency-category`}
                                    component={PendencyReportCat}
                                />
                                <Route
                                    exact
                                    path={`/pendency-officer`}
                                    component={PendencyReportOfficer}
                                />
                                <Route
                                    exact
                                    path={`/pendency-officer-view`}
                                    component={PendencyReportOfficerCount}
                                />
                                <Route
                                    exact
                                    path={`/pendency-view`}
                                    component={PendencyReportCount}
                                />
                                <Route
                                    exact
                                    path={`/school-report`}
                                    component={SchoolReport}
                                />
                                <Route
                                    exact
                                    path={`/vc-report`}
                                    component={VcReport}
                                />
                                <Route
                                    exact
                                    path={`/officer/school-vc-data/:id/:type/:name`}
                                    component={SchoolVCData}
                                />
                                <Route
                                    exact
                                    path={`/officer/school-vc-data/:id/:type`}
                                    component={SchoolVCData}
                                />
                                <Route
                                    exact
                                    path={`/pendency-category`}
                                    component={PendencyReportCat}
                                />

                                {/* Unknown URL while signed in — land on the dashboard
                                    instead of rendering an empty page. */}
                                <Route render={() => <Redirect to="/" />} />

                            </Switch>
                        </div>
                        </RoleRouteGuard>
                    </>
                )}
            </Suspense>
        </div>
    )
}

export default RouteData;